import PropTypes from "prop-types";
import { useEffect, useRef, useContext } from "react";
import { Container, Box, Toolbar, useTheme } from "@mui/material";
import { TopNavHeightContext } from "@context/client/TopNavHeight";
import { useAuth } from "@context/shared/AuthContext";
import { isAccreditor } from "@config/shared/roles";
import { TopNav } from "./top-nav";
import { PrintHeader } from "./print-header";
import { FeedbackButton } from "./feedback-button";

export const MainLayout = (props) => {
  const { children } = props;
  const theme = useTheme();
  const topNavRef = useRef(null);
  const { topNavHeight, setTopNavHeight } = useContext(TopNavHeightContext);
  const { user } = useAuth();
  const accreditor = isAccreditor(user?.roleId);

  useEffect(() => {
    const topNavElement = topNavRef.current;

    if (!topNavElement) return;

    const updateTopNavHeight = () =>
      setTopNavHeight(topNavElement.offsetHeight);

    const resizeObserver = new ResizeObserver(updateTopNavHeight);

    resizeObserver.observe(topNavElement);

    updateTopNavHeight();

    return () => {
      resizeObserver.unobserve(topNavElement);
    };
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        overflow: "hidden",
        "@media print": { overflow: "visible" },
      }}
    >
      <TopNav ref={topNavRef} />
      {!accreditor && <FeedbackButton />}
      <Container maxWidth="100%" disableGutters>
        <Toolbar className="no-print" sx={{ height: `${topNavHeight}px` }} />
        <PrintHeader />

        {children}
      </Container>
    </Box>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node,
};
